import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import { resource as recipeResource } from "@/utils/API/RecipesRepository";
import { RecipeCalculate } from '@/models/Recipes/RecipeCalculate';

const resource = '/dishes';

export default {
  listDishes(listRequest: ListRequest) {
    return Repository.post(`${resource}/listDishes`, listRequest, { withCredentials: true });
  },
  calculate(dishCalculate: RecipeCalculate) {
    return Repository.post(`${recipeResource}/CalculateRecipeNutritions`, dishCalculate, { withCredentials: true });
  },
  deleteDishes(data: any) {
    return Repository.post(`${resource}/DeleteDishes`, data, { withCredentials: true });
  }
};
